<template>
  <v-card class="pb-1" min-width="300" light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Région : {{ region.ll_region }}
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-btn
      class="blue ma-4"
      dark
      :loading="loadingFokontany"
      @click="GetFokontanyDeRegion()"
      v-if="Fokontanys.length == 0"
    >
      charger Fokontany</v-btn
    >
    <vue-excel-xlsx
      v-else
      class="ma-4"
      :columns="headersFokontany"
      :data="Fokontanys"
      :filename="'fokontanys_' + Date.now()"
      :sheetname="'fokontany'"
    >
      <v-btn class="blue" dark>
        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
        Télécharger {{ Fokontanys.length }} Fokontany de la région
        {{ region.ll_region }}</v-btn
      >
    </vue-excel-xlsx>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="_.sortBy(Districts, ['ll_district'])"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="gotToItem(item)">
            mdi-chevron-right
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      headersFokontany: [
        {
          label: "id",
          field: "id",
        },
        {
          label: "id_commune",
          field: "id_commune",
        },
        {
          label: "id_country",
          field: "id_country",
        },
        {
          label: "id_district",
          field: "id_district",
        },
        {
          label: "id_province",
          field: "id_province",
        },
        {
          label: "id_region",
          field: "id_region",
        },
        {
          label: "ll_commune",
          field: "ll_commune",
        },
        {
          label: "ll_district",
          field: "ll_district",
        },
        {
          label: "ll_fokontany",
          field: "ll_fokontany",
        },
        {
          label: "ll_province",
          field: "ll_province",
        },
        {
          label: "ll_region",
          field: "ll_region",
        },
      ],
      loadingFokontany: false,
      region: {},
      Districts: [],
      Fokontanys: [],
      search: "",
      headers: [
        {
          text: "District",
          value: "ll_district",
        },
        { text: "Région", value: "ll_region" },
        { text: "Province", value: "ll_province" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  mounted() {
    this.GetInfosRegionsAndGetDisctricts();
  },
  methods: {
    GetFokontanyDeRegion() {
      let self = this;
      let arrayRegions = [
        self.$route.params.id.toString(),
        parseInt(self.$route.params.id),
      ];
      console.log(arrayRegions);
      self.loadingFokontany = true;
      self.Fokontanys = [];
      self.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_region", "in", arrayRegions)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.Fokontanys.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          self.loadingFokontany = false;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    editItem(item) {
      console.log(item);
    },

    deleteItem(item) {
      this.$confirm("Voulez vous vraiment supprimer ce district").then(
        (res) => {
          if (res) {
            console.log(item);
          }
        }
      );
    },

    gotToItem(item) {
      this.$router.push("/geographie/district/" + item.id);
    },
    GetInfosRegionsAndGetDisctricts() {
      let self = this;
      let arrayRegions = [
        self.$route.params.id.toString(),
        parseInt(self.$route.params.id),
      ];
      var docRef = this.$firebase
        .firestore()
        .collection("regions")
        .doc(this.$route.params.id);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());

            self.region = doc.data();

            self.Disctricts = [];
            self.$firebase
              .firestore()
              .collection("districts")
              .where("id_region", "in", arrayRegions)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  self.Districts.push({
                    ...doc.data(),
                    id: doc.id,
                  });
                });
              })
              .catch((error) => {
                console.log("Error getting documents: ", error);
              });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
  },
};
</script>

<style scoped></style>
